import React, { memo } from "react";
import { SiGoogle } from "react-icons/si";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#db4437";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Gemini"
    accent={accent}
    icon={<SiGoogle style={{ width: 14, height: 14, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.name || data?.prompt || "Google AI Assistant"}
    </div>
  </NodeCard>
));
